import { ReplaySubject } from 'rxjs/ReplaySubject';
import { enCurrency, enLang } from 'interfaces/IProductData';
import { Observable } from 'rxjs/Observable';

export class CurrencyService {
  private currency$ = new ReplaySubject<enCurrency>(1);

  constructor() {
    this.currency$.next(enCurrency.BRL);
  }

  public setCurrencyByLang(language: enLang) {
    const options = [
      { lang: enLang.PT_BR, currency: enCurrency.BRL },
      { lang: enLang.PT_PT, currency: enCurrency.USD },
      { lang: enLang.EN_US, currency: enCurrency.USD }
    ];

    const opt = options.find(i => i.lang === language);

    this.setCurrency(opt.currency);
  }

  public setCurrency(currency: enCurrency) {
    this.currency$.next(currency);
  }

  public getCurrency(): Observable<enCurrency> {
    return this.currency$.asObservable().distinctUntilChanged();
  }
}

// tslint:disable-next-line:variable-name
export const CurrencyServiceFactory = () => new CurrencyService();

export const currencyService = CurrencyServiceFactory();
